import React, { useEffect } from "react";
import "./contactPage.scss";
import "../../utils/Styles/globalclasses.scss";
import ContactFormSection from "./components/contactForm/ContactFormSection";
import UseCaseSection from "./components/useCase/UseCaseSection";
import Footer from "../../components/footer/Footer";

const ContactPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])

  window.scroll({
    top: 0,
    left: 0,
    behavior: "smooth",
  });
  return (
        <div>
          <ContactFormSection />
      <UseCaseSection />
      <Footer />
    </div>
  );
};

export default ContactPage;
